enum InterceptorName {
  LOCAL_AGENT = 'localAgent',
  PROXY = 'proxy',
  WEBRTC_AGENT = 'webrtcAgent'
}
export default InterceptorName;
